export const FLEXIBLE_COMPONENTS = {
    CATEGORY_TAGS: 'CategoryTags',
    PARTNER_PODIUM: 'PartnerPodium',
    ARTICLE_CARDS: 'ArticleCards',
    TESTIMONIALS: 'Testimonials',
    SUMMARY: 'Summary',
    SIDEBAR_BILLBOARD: 'SidebarBillboard',
    HERO_SEARCH_BAR: 'HeroSearchBar',
    HERO_BILLBOARD: 'HeroBillboard',
    PARTNER_CARD_CAROUSEL: 'PartnerCardCarousel',
    BLACK_FRIDAY_BADGE: 'BlackFridayBadge',
    PODIUM_PRO: 'PodiumPro',
};
